export const getTextMetrics = (text, font) => {
    // re-use canvas object for better performance
    const canvas = getTextMetrics.canvas ||
        (getTextMetrics.canvas = document.createElement('canvas'));
    const context = canvas.getContext('2d');
    context.font = font ? font : getElementFont().font;
    const metrics = context.measureText(text);
    return metrics;
};
const getComputedStyle = (element, prop) => {
    return window.getComputedStyle(element, null).getPropertyValue(prop);
};
export const getElementFont = (el = document.body) => {
    const weight = getComputedStyle(el, 'font-weight') || 'normal';
    const size = getComputedStyle(el, 'font-size') || '16px';
    const family = getComputedStyle(el, 'font-family') || 'Times New Roman';
    const style = getComputedStyle(el, 'font-style') || 'normal';
    const variant = getComputedStyle(el, 'font-variant') || 'normal';
    const stretch = getComputedStyle(el, 'font-stretch') || 'normal';
    const lineHeight = getComputedStyle(el, 'line-height') || '1';
    const font = `${style} ${variant} ${weight} ${size}/${lineHeight} ${family}`;
    return { style, variant, weight, stretch, size, lineHeight, family, font };
};
